import React from 'react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import AccountStatement from '../../../components/AccountStatement/AccountStatement.js';

export default function AccountStatementView() {
  return (
    <AdminPageShell title="Estado de cuenta">
      <AccountStatement />
    </AdminPageShell>
  );
}
